<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <i class="fas fa-list-ul"></i> Mutasi {{ metode == 'tunai' ? 'Cash' : 'Transfer' }}
                </div>
                <div class="card-tools mr-0">
                    <button :disabled="isLoading" type="button" class="btn btn-primary" @click="printList">
                        <i class="fas fa-print"></i> Print
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-2">
                    <search-bar @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="alert alert-primary mb-3 font-weight-bold" role="alert" v-if="summary">
                    <div class="row">
                        <div class="col">
                            TOTAL : <strong class="text-nowrap">{{ formatNumber(summary.total) }} GUDANG</strong>
                        </div>
                        <div class="col" v-for="status in summary.status">
                            {{ status.status.toUpperCase() }} : <strong class="text-nowrap">Rp. {{ formatNumber(status.jumlah_nominal) }}</strong>
                        </div>
                    </div>
                </div>
                <div class="table-responsive table-no-action">
                    <vuetable ref="vuetable"
                        api-url="/api/keuangan-logs"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal v-model="viewModal" size="lg" :hide-header="true" :hide-footer="true">
            <viewer :value="currentStock" @cancel="viewModal = false"></viewer>
		</b-modal>
    </section>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import SearchBar from './SearchBar';
import ExportMixin from '../../mixin/export';

export default {
    name: "mutasi-cash",

    props: {
        metode: {
            type: String,
            default: 'tunai',
        },
    },

    components: {
        SearchBar,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            currentStock: null,
            searchText: '',
            searchDate: '',
            searchStatus: '',
            searchJenis: '',
            searchGudangId: '',
            viewModal: false,
            summary: null,
        }
    },

    created() {
    },

    mounted() {
        this.loadSummary();
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'tanggal',
                    title: 'Tanggal',
                    sortField: 'tanggal',
                    callback: 'formatDatetime',
                },
                {
                    name: 'gudang.name',
                    title: 'Gudang',
                    sortField: 'gudang_name',
                    callback: 'formatValue',
                },
                {
                    name: 'nominal',
                    title: 'Nominal',
                    sortField: 'nominal',
                    callback: 'formatNumber',
                },
                {
                    name: 'jenis',
                    title: 'Jenis',
                    sortField: 'jenis',
                },
                {
                    name: 'keterangan',
                    title: 'Keterangan',
                    sortField: 'keterangan',
                    callback: 'formatValue',
                },
                {
                    name: 'status',
                    title: 'Status',
                    sortField: 'status',
                },
            ]
        },

        sortOrder() {
            return [
                { field: "tanggal", direction: "desc" },
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                status: this.searchStatus,
                jenis: this.searchJenis,
                gudang_id: this.searchGudangId,
                metode: this.metode,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchStatus = search.searchStatus;
            this.searchJenis = search.searchJenis;
            this.searchGudangId = search.searchGudangId;
            this.refresh();
            this.loadSummary();
        },

        searchReset() {
            this.searchText = '';
            this.searchDate = '';
            this.searchGudangId = '';
            this.searchStatus = '';
            this.searchJenis = '';
            this.refresh();
            this.loadSummary();
        },

        view(rowData) {
            this.currentStock = Object.assign({}, rowData);
            this.viewModal = true;
        },

        printList(){
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            let params = this.convertExportParams('print');
            newIframe.src = `/keuangan-logs/list/print` + '?' + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function() {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        loadSummary() {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            axios({
                method: 'get',
                url: 'api/keuangan-logs/summary?'+self.convertParams(self.moreParams),
            })
            .then(function (response) {
                self.$Progress.finish();
                self.isLoading = false;
                self.summary = Object.assign({}, response.data);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },
    },
}
</script>
<style>
.vuetable-slot {
    padding-bottom: 0.3rem !important;
}

.table-no-action > .table td {
    padding-top: 0.7rem !important;
    padding-bottom: 0.7rem !important;
}
</style>
